import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { buildPilotMailto } from "@/lib/mailto";

/**
 * Verschijnt na 400px scroll. Alleen zichtbaar op /gemeenten.
 */
export default function StickyPilotCta() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      data-testid="sticky-pilot-cta"
      href={buildPilotMailto()}
      aria-hidden={!show}
      tabIndex={show ? 0 : -1}
      className={`fixed bottom-6 right-6 z-40 group inline-flex items-center gap-3 bg-[#1D2A22] hover:bg-[#E06B3F] text-[#FAF7F1] rounded-full pl-5 pr-2 py-2 transition-all duration-500 shadow-lg ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none invisible"
      }`}
    >
      <span className="text-sm font-medium hidden sm:inline">Plan een verkennend gemeentegesprek</span>
      <span className="text-sm font-medium sm:hidden">Gemeentegesprek</span>
      <span className="bg-[#E06B3F] group-hover:bg-[#FAF7F1] group-hover:text-[#1D2A22] text-white w-9 h-9 rounded-full flex items-center justify-center transition-colors">
        <ArrowUpRight size={16} />
      </span>
    </a>
  );
}
